import { StoreUser } from "./api";

const storageKey = "fulling.store.currentLocationId";

export function rememberStoreLocationId(locationId?: string | null) {
  if (typeof window === "undefined") return;
  if (locationId) window.localStorage.setItem(storageKey, locationId);
}

export function rememberedStoreLocationId() {
  if (typeof window === "undefined") return null;
  return window.localStorage.getItem(storageKey);
}

export function preferredStoreLocationId(user?: StoreUser | null, override?: string | null) {
  const locations = user?.Locations || [];
  const exists = (locationId?: string | null) => Boolean(locationId && locations.some((item) => item.LocationId === locationId));
  if (exists(override)) return override || null;
  const remembered = rememberedStoreLocationId();
  if (exists(remembered)) return remembered;
  if (exists(user?.CurrentLocationId)) return user?.CurrentLocationId || null;
  return locations.find((item) => item.IsPrimary)?.LocationId || locations[0]?.LocationId || null;
}
